import PropTypes from 'prop-types'

export default {
    code: PropTypes.string,
    name: PropTypes.string,
    phone_primary: PropTypes.string,
    phone_secondary: PropTypes.string,
    email: PropTypes.string,
    slug: PropTypes.string,
    postcode: PropTypes.string,
    address: PropTypes.string,
    chain_id: PropTypes.string,
    country_code: PropTypes.string,
    lat: PropTypes.string,
    lng: PropTypes.string,
}
